// extracted by mini-css-extract-plugin
module.exports = {"EmpDetailHeader":"EmpDetailHeader__EmpDetailHeader___1w5Bn","Header":"EmpDetailHeader__Header___2zpD3"};